import { HttpPrefixDirective } from 'components/httpPrefix/httpPrefix.directive';

import template from './addUrl.html';
import './addUrl.scss';

export const AddUrl = angular
    .module('app.pages.editstore.menuEditor.addUrl', [
        HttpPrefixDirective
    ]).component('menuEditorAddUrl', {
        template,
        bindings: {
            prefillUrlData: '<',
            onCancelClick: '&',
            onUrlSaved: '&'
        },
        controller: class MenuEditorAddUrlCtrl {
            $onInit() {
                this.urlData = this.prefillUrlData || {};
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/menuEditor/addUrl.js